export default "__VITE_ASSET__af77345a__"